import React from 'react';
import { AddTopicGroupFlowManager } from 'src/components/BeaconV2Components/ExperimentalLayout/Topics/AddTopicGroupFlowManager';
import { shouldShowBeaconProTopics } from 'src/utils/app';

/**
 * Global components that are mounted in the header for Beacon Pro
 */
export const GlobalComponents = () => {
  return shouldShowBeaconProTopics() && <AddTopicGroupFlowManager />;
};
